import { GzPhoneInputWebComponent } from './component/GzPhoneInputWebComponent';

export { GzPhoneInputWebComponent };
